import React from "react";
import { Helmet } from "react-helmet";

import AboutStaticBanner from "../Components/About/AboutStaticBanner";
import MissionVisionVangal from "../Components/About/MissionVisionVangal";
import AboutUsVangal from "../Components/About/VangalAboutStats";
import ContactSection from "../Components/ContactSection";
import FullWidthImgaeSection from "../Components/FullWidthImageSection";
import VangalTestimonials from "../Components/About/VangalTestimonials";
import TeamSection from "../Components/About/TeamSection";

export default function About() {
  return (
    <>
      <Helmet>
        <title>About Us | Vangal Dairies</title>
        <meta
          name="description"
          content="Learn about Vangal Dairies – our journey since 1993, our values, dairy manufacturing excellence, mission, vision, and commitment to delivering fresh, hygienic, and traditional dairy products."
        />
      </Helmet>

      <AboutStaticBanner />
      <AboutUsVangal />
      <FullWidthImgaeSection />
      <MissionVisionVangal />
      <TeamSection />
      <VangalTestimonials />
      <ContactSection />
    </>
  );
}
